import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";
import { matchPath } from "react-router-dom";
import { CHAT_ELIGIBLE_ROUTES } from "config/chatEligibleRoutes";

export const getAssistantPageCode = (
  pathname: string
): assistantPageCodeEnum | null => {
  return (
    CHAT_ELIGIBLE_ROUTES.find(({ route }) => matchPath(route, pathname))
      ?.code ?? null
  );
};
